<template>
    <v-snackbar
        v-model="snackState.show"
        multi-line
        :color="color"
        :timeout="snackState.timeout"
    >
        {{ snackState.snack.message }}

        <template #actions>
            <v-btn
                icon="mdi-close"
                variant="text"
                @click="snackState.show = false"
            />
        </template>
    </v-snackbar>
</template>

<script setup>
import { inject, computed } from 'vue'
import INJECTION_KEYS from '@injectionKeys'
import { SNACK_LEVEL } from '@lib/state'


/** @type {SnackState} */
const snackState = inject(INJECTION_KEYS.SNACKSTATE)

const color = computed(() => {
    if (!snackState.snack) return ''
    switch (snackState.snack.level) {
        case SNACK_LEVEL.ERROR:
            return 'error'
        case SNACK_LEVEL.WARNING:
            return 'warning'
        case SNACK_LEVEL.INFO:
            return 'primary'
        case SNACK_LEVEL.SUCCESS:
            return 'success'
        default:
            return ''
    }
})
</script>